import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import AppModel from '../DataModel/AppModel';
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import Checkbox from 'material-ui/Checkbox';

export default
@observer class RoleChecker extends Component {

  handleChange(event, index, value) {
    console.log(arguments);
    this.props.target.id_type = value;
  }

  toggleUserRole(user,id_role,role_name) {
    return function() {
      user.toggleRole(id_role,role_name);
    }
  }

  // Workaround for a bug in IE where checkboxes
  // are able to be clicked when user doubleclick them,
  // regardless of disabled status;
  noop() {
    console.log("Checkbox should not be clickable.  Does nothing.");
  }

  render() {
    var form = this.props.form;
    var user = form.user;
    var prev_roles = form.prev_roles;
    // For the settings page, users are not allowed to change the checkboxes
    var displayOnly = ( user.id==AppModel.id_user );
    return (
      <List style={{paddingLeft:'16px'}} >
        <Subheader style={{position:'relative',left:'-16px'}}>
          {uiMsg('RCHK_H_PERMISSIONS',"Permissions")}</Subheader>
        {AppModel.grantableRoles
          .filter( gr => !gr.hidden
            || user.hasRole(gr.id_role)
            || prev_roles.has(gr.id_role)
          )
          .map( gr =>
            <ListItem
              key={gr.id_role}
              leftCheckbox={
                <Checkbox checked={user.hasRole(gr.id_role)}
                          disabled = {displayOnly}
                          onCheck={displayOnly ? this.noop
                            : this.toggleUserRole(user,gr.id_role,gr.name)}
                />
              }
              primaryText={uiMsg("RCHK_ROLE_NAME_"+gr.id_role,gr.name)}
            />
          )
        }
      </List>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/RoleChecker.jsx
 **/